var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcelC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 410 311.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff8f8;}.cls-2{fill:#3b364d;}.cls-3{fill:#ffe5e2;}.cls-4{fill:#aab2c8;}.cls-5{fill:#e0e7ff;}.cls-27,.cls-28,.cls-6{fill:none;stroke-miterlimit:10;}.cls-6{stroke:#aab2c8;}.cls-7{fill:#fff;}.cls-20,.cls-7{opacity:0.54;}.cls-8{fill:#773c4d;}.cls-9{fill:#965363;}.cls-10{fill:#61648a;}.cls-11{fill:#edf1fc;}.cls-12{fill:#ffc55a;}.cls-13{fill:#af2f48;}.cls-14{fill:#d4ecff;}.cls-15{fill:#5793ce;}.cls-16{fill:#396caa;}.cls-17{fill:#699dd1;}.cls-18{fill:#d35473;}.cls-19{fill:#31344c;}.cls-20{fill:#232433;}.cls-21,.cls-24{fill:#383952;}.cls-22{fill:#6d3744;}.cls-23{fill:#542633;}.cls-24,.cls-34{opacity:0.36;}.cls-25{fill:#f4b8ab;}.cls-26{fill:#c3c9f4;}.cls-27{stroke:#191918;stroke-width:2px;}.cls-28{stroke:#e56a85;stroke-linecap:round;}.cls-29{fill:#dd6595;opacity:0.53;}.cls-30{fill:#7c9e1e;}.cls-31{fill:#b7ac15;}.cls-32{fill:#a88f14;}.cls-33,.cls-34{fill:#426313;}.cls-35{fill:#3a3852;}.cls-36{fill:#274f89;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M430.55,401.12c53.24-54.44,30.19-138.91-73-158.18S232.2,108.23,138.39,132.31,9,333.67,105.24,401.12Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 423.99,
    y: 222.88,
    width: 6.56,
    height: 164.27,
    transform: "translate(806.28 507.35) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183,401.12c0,2.38-20.87,4.31-46.62,4.31s-46.62-1.93-46.62-4.31,20.87-4.31,46.62-4.31S183,398.74,183,401.12Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 261.02,
    cy: 303.04,
    rx: 90.62,
    ry: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2.75,
    width: 147.91,
    height: 131.12,
    rx: 10.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 12.77,
    y: 10.84,
    width: 127.85,
    height: 109.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 76.7,
    y1: 10.84,
    x2: 76.7,
    y2: 120.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 140.63,
    y1: 65.56,
    x2: 12.77,
    y2: 65.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "68.71 10.84 25.83 120.2 44.79 120.2 88.13 10.84 68.71 10.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "101.86 10.84 58.98 120.2 77.95 120.2 121.29 10.84 101.86 10.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 280.82,
    y: 114.33,
    width: 125.9,
    height: 11.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 326.42,
    y: 114.33,
    width: 80.3,
    height: 11.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M308.07,95.47H372.3a0,0,0,0,1,0,0v18.86a0,0,0,0,1,0,0H308.07a4,4,0,0,1-4-4V99.51A4,4,0,0,1,308.07,95.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 308.98,
    y: 99.45,
    width: 64.41,
    height: 10.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 308.82,
    y: 99.45,
    width: 45.98,
    height: 10.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M297.53,76.61h64.22a0,0,0,0,1,0,0V95.47a0,0,0,0,1,0,0H297.53a4,4,0,0,1-4-4V80.66A4,4,0,0,1,297.53,76.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 298.28,
    y: 80.59,
    width: 64.41,
    height: 10.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.28,
    y: 80.59,
    width: 46.3,
    height: 10.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M312.09,57.75h64.22a0,0,0,0,1,0,0V76.61a0,0,0,0,1,0,0H312.09a4,4,0,0,1-4-4V61.8A4,4,0,0,1,312.09,57.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 313.06,
    y: 61.73,
    width: 64.41,
    height: 10.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 312.84,
    y: 61.73,
    width: 43.41,
    height: 10.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M353.05,314.13c.09,14-1.24,27.4-4.86,39.44,0,0,0,0,0,0-10.17,33.69-38.42,56.91-104.49,54.76-89.67-2.92-106-86.3-113.48-164.26-6.11-63.26,12.9-109.82,70-125.14,13.27-3.56,28.61-5.44,46.16-5.44C327.06,113.52,352.71,260.79,353.05,314.13Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M348.18,353.6c-10.17,33.69-38.42,56.91-104.49,54.76-89.67-2.92-106-86.3-113.48-164.26-6.11-63.26,12.9-109.82,70-125.14-49,29.89-61.2,84.33-41.16,167.15s70.57,106.91,103.31,107S336.16,382.45,348.18,353.6Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M223.64,191.7c-64,11.39-36.06,102.76-21.92,128.34s20.16,55.88,52.83,57.23S329,363.8,333,353s-14.44-66.92-14.44-66.92S316,229.29,298.3,214.36,244.88,187.92,223.64,191.7Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M309.28,345.79c-11.69,21.84-51.51,29.52-65.16,26.06-8-2-17.67-9.33-26.43-19.8-5.59-9.86-10.08-21.35-16-32a124.42,124.42,0,0,1-7.24-16.29c-4.88-23.46-4.73-51.32,4.43-60.81C211.35,230.06,223.42,221,224.29,213c.67-6.26-6.43-14.51-5-20.38,1.39-.35,2.84-.67,4.35-.93,17.5-3.12,44.8,4.14,63.79,15.14,1.83,6.92,2,16.19,6.28,19.2,6.61,4.6,16.83,33.46,19.42,47S309.28,345.79,309.28,345.79Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M396.15,380.44c.52,8.22,24.3-2.27,27.45-6.82,0,0-13,37.42-19.8,37.42s-25.26-19.49-25.26-19.49l2.22-11.11Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M403.8,411c-7.38,3.16,11.06-43.36,19.8-42.32S413.32,407,403.8,411Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M399,326.56c-.48,24.06-6.73,53.88-6.73,53.88h-15.4s-9.46-20.3-13.9-40.73a94.49,94.49,0,0,1-2.16-15.07s-23.86,7.21-47,2.88a275.19,275.19,0,0,1-29.91-7.8c-13.23-4.13-23.61-8.07-23.61-8.07l.78-1,16.84-21.3,45.32-6.82,5.31-.8,32.22,10C389.37,294.81,399.47,302.51,399,326.56Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M363,339.71a94.49,94.49,0,0,1-2.16-15.07s-23.86,7.21-47,2.88a275.19,275.19,0,0,1-29.91-7.8l-22.83-9.06-2-.8-3.79-15.75,48.75-17,19.19,5.46,32.24,9.17c-7.79,14,7.89,30.56,11.33,35.53s13.23-3.06,19.43,0S367.88,328.84,363,339.71Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M372,393.91c7.08,15.38,17.58,22.72,23.17,20.28l-2.45-25.53-10.13-4.37Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M395.21,414.19c-12.46,2.07-10.14-22-9.44-33.75s10.49-10.67,11.54-1.57S403.6,412.79,395.21,414.19Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M382.63,384.28l-10.58,9.63c-43.3-12.51-68.79-52-68.79-52-24.06,27.9-51,34.16-72.67,0,0,0,1.37-15.18,18.95-26.88a63.29,63.29,0,0,1,12.17-6.3c18.8-7.45,43.81-8.89,59.21-9a28.47,28.47,0,0,1,23.38,12.07c9.06,12.81,17.7,28.7,24.48,42.33C377.11,371,382.63,384.28,382.63,384.28Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M382.63,384.28l-10.58,9.63c-43.3-12.51-68.79-52-68.79-52-24.06,27.9-51,34.16-72.67,0,0,0,1.37-15.18,18.95-26.88l18.14-3.36C246.5,353.3,297.42,343.6,306.6,336s17.86-15.19,22-15.61S311,336,326.29,354.19s50.48,29.56,42.49,0C377.11,371,382.63,384.28,382.63,384.28Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M277.1,177.15h-.64s-6.42,24.55-17.35,33.7a13.86,13.86,0,0,1-6.35,3.21c-14.75,2.73-27.61-14.08-30-25.61-1.36-6.45,1-10.41,3.42-12.63a12.08,12.08,0,0,1,3.73-2.47s1-18.18,7.3-17.85c6.09.31,5.07,2.73,5,2.91.4-.52,13.65-18.15,22.77-16.23s2.76,15.58,2.76,15.58,11.69-11.84,15.58-5-7.62,15.1-7.62,15.1,9.9-.16,10.87,3.42S286,178.23,277.1,177.15Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M259.11,210.85a13.86,13.86,0,0,1-6.35,3.21c-14.75,2.73-27.61-14.08-30-25.61-1.36-6.45,1-10.41,3.42-12.63,2.19,2.85,5.13,8.57,11.83,1.33h3.11Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M298.3,283.88l-67.38,62.47a68.88,68.88,0,0,1-8.59-9.23h0a66.89,66.89,0,0,1-10.21-18.79,84,84,0,0,1-3.77-15.22c-1.85-11.84-1.6-24.21-.85-36.5,1.76-28.78,10.45-48,45-48.48,0,0,15.84-4.43,27.56,1.89,9.22,5,15.22,41.63,17.37,57.06C298,281.26,298.3,283.88,298.3,283.88Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M284,255.44c-35.47,13.3-50.16-12.5-50.16-12.5l-11.47,41.23,24.55,7.56,42.72-4.45Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M298.3,283.88l-67.38,62.47a68.88,68.88,0,0,1-8.59-9.23c11.72-.88,36.9-28.91,30.28-30.38-5.91-1.3-26.28,12.56-40.5,11.59a84,84,0,0,1-3.77-15.22L230,284.16l67.43-7.08C298,281.26,298.3,283.88,298.3,283.88Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M260.32,275.58c7.91-5.34,17.12-.89,20.39,1.49s0,8.62,0,8.62a34.56,34.56,0,0,0-4.75-2.38c-1.19-.3-6.92,4.16-18.32,2.38S260.32,275.58,260.32,275.58Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M214.08,238.26c15.52-11.57,24.31-1.4,23.56,18.6l-.75,20s19.79-6.31,24.63-6.31c0,0,.43,13.68,0,18.59,0,0-23.93,23.16-39.72,24.92s-12.63-29.48-14-43.87S208.69,242.28,214.08,238.26Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M278,286.61l11.77-47.68a10.89,10.89,0,0,1,10.57-8.28h67.55a6.8,6.8,0,0,1,6.59,8.48L360.83,289Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M282.71,286.61l11.77-47.68a10.89,10.89,0,0,1,10.57-8.28H372.6a6.8,6.8,0,0,1,6.59,8.48L365.56,289Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M346,291.37h-86a2.38,2.38,0,0,1-2.37-2.38h0a2.38,2.38,0,0,1,2.37-2.38h86a2.39,2.39,0,0,1,2.38,2.38h0A2.39,2.39,0,0,1,346,291.37Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M366.3,291.37H280.35A2.38,2.38,0,0,1,278,289h0a2.38,2.38,0,0,1,2.37-2.38H366.3a2.39,2.39,0,0,1,2.38,2.38h0A2.39,2.39,0,0,1,366.3,291.37Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M337.56,259.68c-1.13,6.2-3.94,10.88-6.28,10.46s-3.3-5.8-2.17-12,3.94-10.88,6.28-10.45S338.69,253.48,337.56,259.68Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M281,181.13c1.49,22-2,31.69-14.47,32.94v5.11a6.86,6.86,0,0,1-6.86,6.86h0a6.87,6.87,0,0,1-6.87-6.86v-5.11s-10-4.24-12-10.48,0-1,0-1l-.89-25.45h41.38Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M241.42,193c-3.14-5.72-6.83-3.32-7.57,0s5.91,11.41,7.57,8.56S241.42,193,241.42,193Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M234.54,174.33c6.68,8.11,25.62,12.33,32.47,10.39s-2.89-8.28-2.89-8.28,12.71,8.76,18.53,5.84-9.87-10.06-9.87-10.06Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M257.23,191.7c0,1.18-.21,2.13-.47,2.13s-.47-1-.47-2.13.21-2.12.47-2.12S257.23,190.53,257.23,191.7Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M270.72,191.7c0,1.18-.21,2.13-.47,2.13s-.48-1-.48-2.13.22-2.12.48-2.12S270.72,190.53,270.72,191.7Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M265.28,203.56c-6.46.15-11.47-4.5-11.47-4.5",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M266.49,214.07a117.62,117.62,0,0,1-11.94.29l11.94,4.82Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M241.08,194.56c-2.79-2.93-4.17-1.73-4,1.32s3.86,5.24,5.06,4.37S241.08,194.56,241.08,194.56Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M131.68,347.46c-12.41-4.56-19.24-2.78-23-7.85,0,0,10.13-1.77,15.7,0Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M124.34,339.61c-15.08-7.88-19.55-16.82-23.38-23s-6-11.29-7.46-11.72,6.18,1.07,13.42,8.31,10.22,8.3,16,14.05,10.86,14.21,11.5,20.2h-2.71Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M128.64,337.48c-8.15-12.5-.84-19.68-10.65-33.85-11.5-16.61-7.88-33.22-6.17-43.66,0,0-2.56,12.15,7.45,24s19.8,16.39,20.65,34-2.55,29.51-2.55,29.51h-5.69Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M136.05,347.46c-2.73-11.71,2.6-31.7,3-51.5s-10.65-34.5,5.75-53c0,0-3.41,3.41,1.28,17s15.12,27.9,10,46.21S140,339.49,140.06,347.46Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M140.06,347.46c-1.7-14,12.64-36,24.78-40.85a27,27,0,0,1-6.6,19.54c-7.88,8.78-13.74,21.31-13.74,21.31Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M144.5,347.46c.53-9.34,8.63-12.61,16.93-15,0,0-10,10.1-11.71,15Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M148.4,348.53c1.41-7.08,4.6-9.3,4-9.7s-4.22,5.55-6,8.63c0,0-2.43-8.07,1.21-15s7.07-12.21,7.07-12.21-11.72,13.54-12.33,20.39a43.92,43.92,0,0,1,.81-15.76c2-8.88,7.28-17.37,5.36-27.88s-4-21.73-4-21.73.87,10.69,1.88,19.95-1.74,14.11-4.41,24-1.17,24-2.33,23.92-3,2.56-3,2.56-1.22-15.16-3-28.1-1.62-14.68-9.5-22.4-8.9-12.44-8.9-12.44,5.33,10.58,9.74,17.46,5.83,9.9,5.83,22,.61,18.95,1.62,20.89S125,331.62,118.28,327a61.4,61.4,0,0,1-12.74-11.86c-.6-1,6.47,11.72,11.73,15.16s14.41,15.16,14.41,15.16l-15-4.05,17,7.08Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M161.79,351.24l-8,46a4.73,4.73,0,0,1-.56,1.54,4.65,4.65,0,0,1-4,2.31H120.47a4.64,4.64,0,0,1-4.59-3.9l-7.49-46a4.65,4.65,0,0,1,4.59-5.4H157.2A4.66,4.66,0,0,1,161.79,351.24Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M153.24,398.81a4.65,4.65,0,0,1-4,2.31H120.47a4.64,4.64,0,0,1-4.59-3.9l-7.49-46a4.65,4.65,0,0,1,4.59-5.4h15.21C114.09,367.69,137.6,393.14,153.24,398.81Z",
    transform: "translate(-48.26 -102.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M201.72,320c5.89,10.66,10.38,22.15,16,32a115,115,0,0,1-16.26-25.9,108.43,108.43,0,0,1-7-22.4A124.42,124.42,0,0,0,201.72,320Z",
    transform: "translate(-48.26 -102.68)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelC);
export default __webpack_public_path__ + "static/media/excel-c.f876d281beea72c187bc00cdb6683630.svg";
export { ForwardRef as ReactComponent };